// extracted by mini-css-extract-plugin
export default {"contract-preamble":"styles_contract-preamble__SiSev"};